import axios from "axios";
import { setLoader } from "../Slices/loaderSlice.jsx";
import { SERVER_URL } from "../databucket";
import { message } from "antd";

export const handleMultipleAttachment = async (attachments, details, dispatch, id, Empid) => {
  const employee = details?.find((emp) => emp?.id === id);

  const formData = new FormData();
  attachments.forEach(att => {
    formData.append('files', att.file);
  });

  try {
    dispatch(setLoader(true));

    const res = await axios.post(`${SERVER_URL}/upload`, formData);
    const uploadedFiles = res.data.files.map(uploadedItem => {
      const fileMeta = {
        _id: uploadedItem._id || undefined, 
        userId: id,
        emailId: Empid,
        data: uploadedItem.url,
        replacedFile: null,
        userName: `${employee?.firstname ?? ''}${employee?.lastname ?? ''}`,
        filename: uploadedItem.originalName,
        mimetype: uploadedItem.mimeType,
        addDate: Date.now().toString(),
        updateDate: null,
        status: true,
        deleteDate: null,
        attachmetHistory: []
      };
      return fileMeta;
    });

    message.success({
      content: "Uploaded Successfully",
      duration: 2
    });

    return uploadedFiles;

  } catch (err) {
    message.error({
      content: "Upload failed",
      duration: 2
    });
    
  } finally {
    dispatch(setLoader(false));
  }
};
export const handleUpdateAttachment = async (file, file2, rowId, dispatch, details, id,) => {
  if (!file || !rowId) return
  const employee = details?.find((emp) => emp?.id === id);
  const inputElement = document.createElement('input');
  inputElement.type = 'file';
  inputElement.style.display = 'none';
  document.body.appendChild(inputElement);

  const selectedFile = await new Promise((resolve) => {
    inputElement.onchange = (e) => resolve(e.target.files[0]);
    inputElement.click();
  });

  document.body.removeChild(inputElement);
  if (!selectedFile) return;

  const formData = new FormData();
  formData.append('files', selectedFile);

  try {
    dispatch(setLoader(true));

    const res = await axios.post(`${SERVER_URL}/upload`, formData);
    const savedFile = res.data.files[0];

    const valuesObject = {
      emailId: file2?.id,
      replacedFile: file2.filename,
      data: savedFile.url,
      filename: savedFile.originalName,
      mimetype: savedFile.mimeType,
      updateDate: Date.now().toString(),
      addDate: file2.addDate ? file2.addDate : Date.now().toString(),
      deleteDate: null,
      status: true,
      userName: `${employee?.firstname}${employee?.lastname}`,
    };
    return valuesObject;

  } catch (error) {
    message.error('Failed to update attachment');
  } finally {
    dispatch(setLoader(false));
  }
};
export const handleDeleteAttachment = async (attachmentId, rowId,type) => {
  if (!attachmentId || !rowId) return;
  try {
    const valuesObject = {
      id: rowId,
      userId: attachmentId?.id,
      input: {
        emailId: attachmentId?.emailId,
        userId: attachmentId?.userId,
        data: attachmentId?.data,
        addDate: attachmentId?.addDate,
        replacedFile: attachmentId?.oldfile,
        filename: attachmentId?.filename,
        mimetype: attachmentId?.mimetype,
        deleteDate: Date.now().toString(),
        status: false,
      },
    }
    return valuesObject;

  } catch {
    message.error({
      content: "Faild to delet",
      duration: 2
    })
  }
};
